// @flow

export const prepareBasename = (basename) => `/${basename.replace(/^\//, '')}`
